export const blocFioConstants = {
  GET_BLOCFIO_REQUEST: 'GET_BLOCFIO_REQUEST',
  GET_BLOCFIO_SUCCESS: 'GET_BLOCFIO_SUCCESS',
  GET_BLOCFIO_FAILURE: 'GET_BLOCFIO_FAILURE',

  UPDATE_BLOCFIO_REQUEST: 'UPDATE_BLOCFIO_REQUEST',
  UPDATE_BLOCFIO_SUCCESS: 'UPDATE_BLOCFIO_SUCCESS',
  UPDATE_BLOCFIO_FAILURE: 'UPDATE_BLOCFIO_FAILURE',
};
